var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1,-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 22,
    height: 20,
    rx: 3,
    fill: "#02230D",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,-1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0136,11.88427L6.984781,11.88427C6.59251,11.88427,6.237989,11.63782,6.082065,11.257729999999999C5.9255197,10.87795,5.99709056,10.43614,6.264249,10.1331L8.73441,7.331929C9.10491,6.9105715,9.7285,6.887243,10.12623,7.279862C10.523430000000001,7.672095,10.5464,8.3316,10.17547,8.7516L9.24978,9.80161L16.0152,9.80161C16.558500000000002,9.80161,17,10.26847,17,10.84294C17,11.4174,16.558500000000002,11.884260000000001,16.0136,11.88427ZM13.543420000000001,19C13.302150000000001,19,13.06252,18.908,12.87213,18.720599999999997C12.47493,18.3283,12.45195,17.668799999999997,12.822890000000001,17.2488L13.74858,16.19883L6.984781,16.19883C6.44151,16.19883,6,15.73197,6,15.1575C6,14.58304,6.44151,14.11618,6.984781,14.11618L16.0152,14.11618C16.4075,14.11618,16.762,14.36262,16.9179,14.742709999999999C17.073900000000002,15.1228,17.0033,15.56536,16.7357,15.86734L14.26559,18.6685C14.07886,18.8803,13.81723,19.0004,13.543420000000001,19Z",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversionIcon);
export default __webpack_public_path__ + "static/media/conversionIcon.dfaf25934f07bc077a068d1d22441636.svg";
export { ForwardRef as ReactComponent };